<template>
  <BModal :id="id" :visible="show" scrollable size="xl" body-class="bg-auth-4" @hide="$emit('hide')">
    <template #modal-header>
      <h5 class="mb-3 mt-auto ml-auto mr-auto modal-title">Your Discounts</h5>
      <button type="button" class="modal-close" aria-label="Close" @click="$emit('hide')">
        <i class="fa fa-times-thin" style="font-size: 1.5em" />
      </button>
    </template>
    <div v-if="pricingTierDiscounts && pricingTierDiscounts.id" class="mx-3">
      <div v-if="pricingTierDiscounts.type == 'Total'">
        <BushelCard class="my-2">
          <h5 class="mb-0">
            {{ `${"You have been given an additional"}  ${pricingTierDiscounts.percent}% of your order total` }}
          </h5>
        </BushelCard>
      </div>
      <div v-else>
        <BushelCard class="my-2">
          <h5 class="mb-0">As a thank you for being one of our buyers, we are happy to offer your company these specific discounts:</h5>
        </BushelCard>
        <BushelCard v-for="price in pricingTierDiscounts.pricing_tier_prices" :key="price.id" class="my-2">
          <!-- <h5 class="mb-0">
            {{ `${'You have been given an additional'} ${price.percent}%  ${'You have been given an additional'.toLowerCase()} ${price.product_category.name} ${price.product_type_id ? ' - ' : ''} ${price.product_type_id ? price.product_type.name : ''}` }}
          </h5> -->
          <h5 class="mb-0">
            <span>
              {{
                `${price.product_category.name}${price.product_type_id ? " - " : ":"} ${price.product_type_id ? price.product_type.name + ":" : ""}`
              }}
            </span>

            <span v-if="price.version == 'Percent'">
              {{ `${price.percent}%` }}
            </span>

            <span v-else-if="price.version == 'Dollar'">
              {{ currency(price.dollar) }}
            </span>

            <span v-if="price.unit_measurement && price.unit_measurement.name"> / {{ price.unit_measurement.name }} </span>

            <span>
              {{ `${price.direction == "Discount" ? "Discount".toLowerCase() : "Discount".toLowerCase()}` }}
            </span>

            <span v-if="price.product_category && price.product_category.name && tableRowCanSeePackagesAndCases(price.product_category)">
              for
              <span v-if="price.applies_to_singles">
                Singles<span v-if="price.applies_to_packages && price.applies_to_cases">,</span
                ><span v-else-if="price.applies_to_packages || price.applies_to_cases"> and</span></span
              >
              <span v-if="price.applies_to_packages">
                Packages<span v-if="price.applies_to_singles && price.applies_to_cases">, and</span
                ><span v-else-if="price.applies_to_cases"> and</span></span
              >
              <span v-if="price.applies_to_cases"> Cases</span>
            </span>
            <span v-if="price.brand && price.brand.name">
              on
              <span v-if="price.applies_to_singles"> {{ price.brand.name }}</span>
            </span>
          </h5>
        </BushelCard>
      </div>
    </div>
    <template #modal-footer>
      <BushelBtn variant="secondary" ripple-color="secondary" flat @click="$emit('hide')"> Close </BushelBtn>
    </template>
  </BModal>
</template>

<script>
import { showPackageAndCaseOptions } from "@/services/inventory/showProductFieldChecks";
import { currency } from "@/services/filters";

export default {
  components: {},
  props: {
    show: { type: Boolean, required: true },
    id: { type: String, default: "pricingTierDiscountsModal" },
    pricingTierDiscounts: { type: Object },
  },
  emits: ["hide"],
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    currency,
    tableRowCanSeePackagesAndCases(category) {
      return showPackageAndCaseOptions(category);
    },
  },
};
</script>
